var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mi:add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3.3335C10.2211 3.3335 10.433 3.42129 10.5893 3.57757C10.7456 3.73385 10.8334 3.94582 10.8334 4.16683V9.16683H15.8334C16.0544 9.16683 16.2663 9.25463 16.4226 9.41091C16.5789 9.56719 16.6667 9.77915 16.6667 10.0002C16.6667 10.2212 16.5789 10.4331 16.4226 10.5894C16.2663 10.7457 16.0544 10.8335 15.8334 10.8335H10.8334V15.8335C10.8334 16.0545 10.7456 16.2665 10.5893 16.4228C10.433 16.579 10.2211 16.6668 10 16.6668C9.77903 16.6668 9.56707 16.579 9.41079 16.4228C9.2545 16.2665 9.16671 16.0545 9.16671 15.8335V10.8335H4.16671C3.94569 10.8335 3.73373 10.7457 3.57745 10.5894C3.42117 10.4331 3.33337 10.2212 3.33337 10.0002C3.33337 9.77915 3.42117 9.56719 3.57745 9.41091C3.73373 9.25463 3.94569 9.16683 4.16671 9.16683H9.16671V4.16683C9.16671 3.94582 9.2545 3.73385 9.41079 3.57757C9.56707 3.42129 9.77903 3.3335 10 3.3335Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.4f0b0996f3c63d93e4e3e86b41bbde9e.svg";
export { ForwardRef as ReactComponent };